import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
const Error = ({ error, className }) => {
    return (
        <div className={className}>
            <div className='text-error flex flex-col justify-center items-center'>

                <FontAwesomeIcon className='text-[100px]' icon={faCircleExclamation}></FontAwesomeIcon>
                <h1 className='text-4xl font-bold text capitalize mt-5'>{error || "Not Found"}</h1>

            </div>
        </div>
    );
};

export default Error;